module.exports = __webpack_public_path__ + "static/img/3areaA_4.751e121.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/3areaA_4.png
// module id = 862
// module chunks = 1